/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  
  LOAD_OBS_LIST,
  LOAD_OBS_LIST_SUCCESS,
  LOAD_OBS_LIST_ERROR,



  UPDATE_OBS_LIST,
  UPDATE_OBS_LIST_SUCCESS,
  UPDATE_OBS_LIST_ERROR,

  
  DELETE_OBS,
  DELETE_OBS_ERROR,
  DELETE_OBS_SUCCESS,

  ADD_FOLLOWUP,
  ADD_FOLLOWUP_SUCCESS,
  ADD_FOLLOWUP_ERROR,

  LOAD_FOLLOWUP,
  LOAD_FOLLOWUP_SUCCESS,
  LOAD_FOLLOWUP_ERROR,

  UPDATE_AGENT,
  UPDATE_AGENT_SUCCESS,
  UPDATE_AGENT_ERROR

} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(obsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    obsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadObsList(searchFilter) {
  return {
    type: LOAD_OBS_LIST,
    searchFilter,
  }
}

export function loadObsListSuccess(obs_list) {
  return {
    type: LOAD_OBS_LIST_SUCCESS,
    obs_list,
  }
}

/**
 * @param {string} error
 */

export function loadObsListError(error) {
  return {
    type: LOAD_OBS_LIST_ERROR,
    error,
  }
}

export function loadFollowUp(ID) {
  return {
    type: LOAD_FOLLOWUP,
    ID,
  }
}

export function loadFollowUpSuccess(followup_list) {
  return {
    type: LOAD_FOLLOWUP_SUCCESS,
    followup_list,
  }
}

/**
 * @param {string} error
 */

export function loadFollowUpError(error) {
  return {
    type: LOAD_FOLLOWUP_ERROR,
    error,
  }
}
//load followup 

//Employee list Update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateObsList(obsDetails) {
  return {
    type: UPDATE_OBS_LIST,
    obsDetails,
  }
}

export function updateObsListSuccess(obsDetails, success) {
  return {
    type: UPDATE_OBS_LIST_SUCCESS,
    obsDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateObsListError(error) {
  return {
    type: UPDATE_OBS_LIST_ERROR,
    error,
  }
}

export function addFollowUp(submitFollowUp) {
  return {
    type:ADD_FOLLOWUP,
    submitFollowUp,
  }
}

export function addFollowUpSuccess(submitFollowUp, success) {
  return {
    type: ADD_FOLLOWUP_SUCCESS,
    submitFollowUp,
    success,
  }
}

/**
 * @param {string} error
 */

export function addFollowUpError(error) {
  return {
    type:ADD_FOLLOWUP_ERROR,
    error,
  }
}



export function deleteObs(deleteData) {
  return {
    type: DELETE_OBS,
    deleteData,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteObsSuccess(deleteData, success) {
  return {
    type: DELETE_OBS_SUCCESS,
    deleteData,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteObsError(error) {
  return {
    type: DELETE_OBS_ERROR,
    error,
  }
}


export function updateAgent(agent_data) {
  return {
    type:UPDATE_AGENT,
    agent_data,
  }
}

export function updateAgentSuccess(success) {
  return {
    type: UPDATE_AGENT_SUCCESS,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateAgentError(error) {
  return {
    type:UPDATE_AGENT_ERROR,
    error,
  }
}


const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  //Leave list
  loadObsList,
  loadObsListSuccess,
  loadObsListError,
  
  updateObsList,
  updateObsListSuccess,
  updateObsListError,
  

  deleteObs,
  deleteObsSuccess,
  deleteObsError,

  addFollowUp,
  addFollowUpSuccess,
  addFollowUpError,

  loadFollowUp,
  loadFollowUpSuccess,
  loadFollowUpError,

  updateAgent,
  updateAgentSuccess,
  updateAgentError

}

export default actions
